<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

<!--    종사자 정보-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('종사자 정보') }}</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('사번') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('소속명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('부서명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_3"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('성명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_4"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

<!--    발병위험인자-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('발병위험인자') }}</h5>
        </vs-col>
      </vs-row>
      <vs-row class="my-4">
        <table class="mb-4 table-wrap">
<!--          문진-->
          <tr>
            <th class="p-4 th-cell" colspan="2">{{ $t('문진') }}</th>
          </tr>
          <tr>
            <td class="p-4 td-cell">{{ $t('성, 연령') }}</td>
            <td class="p-4 td-cell flex">
              <vs-radio class="mr-4" v-model="form.inputC_1" vs-value="남" color="secondary" :disabled="board.readonly">남</vs-radio>
              <vs-radio v-model="form.inputC_1" vs-value="여" color="secondary" :disabled="board.readonly">여</vs-radio>
              <div class="flex px-4" style="align-items: center;">
                <span class="title mr-2">만</span>
                <div v-if="isPrint" class="print-input text-right" >{{ form.age }}</div>
                <ml-input v-else class="input-small" v-model="form.age" :readonly="board.readonly" />
                <div>
                  <span class="title ml-2">세</span>
                  <span class="small-font">주1)</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="p-4 td-cell">{{ $t('흡연') }}</td>
            <td class="p-4 td-cell flex">
              <vs-radio class="mr-4" v-model="form.inputC_2" vs-value="현재 하고 있다" color="secondary" :disabled="board.readonly">{{ $t('현재 하고 있다') }}</vs-radio>
              <vs-radio v-model="form.inputC_2" vs-value="안 한다" color="secondary" :disabled="board.readonly">{{ $t('안 한다') }}</vs-radio>
            </td>
          </tr>
          <tr>
            <td class="p-4 td-cell">{{ $t('신체 활동부족') }}</td>
            <td class="p-4 td-cell flex">
              <vs-radio class="mr-4" v-model="form.inputC_3" vs-value="규칙적으로 한다" color="secondary" :disabled="board.readonly">{{ $t('규칙적으로 한다') }}</vs-radio>
              <vs-radio v-model="form.inputC_3" vs-value="운동부족이다" color="secondary" :disabled="board.readonly">{{ $t('운동부족이다') }}</vs-radio>
              <span class="small-font">주2)</span>
            </td>
          </tr>
          <tr>
            <td class="p-4 td-cell">{{ $t('가족력') }}</td>
            <td class="">
              <table style="width: 100%; border-spacing: 0; border-right: 1px solid #cdcdcd; border-bottom: 1px solid #cdcdcd;">
                <tr>
                  <td class="px-4" style="border-bottom: 1px solid #cdcdcd; height: 50px; font-weight: 500;">
                    <span>{{ $t('직계가족의 심혈관질환 조기발병') }}</span>
                    <span class="small-font">주3)</span>
                  </td>
                </tr>
                <tr>
                  <td class="px-4" style="height: 50px;" >
                    <div class="flex pr-4" style="align-items: center;">
                      <span class="title mr-2">{{ $t('직계가족') }}</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.family_name }}</div>
                      <ml-input v-else class="input-small" v-model="form.family_name" :readonly="board.readonly" />
                      <span class="title mx-2">가</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.family_disease_age }}</div>
                      <ml-input v-else class="input-small" v-model="form.family_disease_age" :readonly="board.readonly" />
                      <span class="title mx-2">{{ $t('세 경에') }}</span>

                      <div
                        class="flex"
                        v-for="(row, indexRows) in form.family_disease"
                        :key="indexRows"
                      >
                        <template v-if="isPrint">
                          <div
                            class="item-box-check"
                            style="text-align: center;  align-self: center;"
                          >
                            <vs-icon icon="check" size="medium"></vs-icon>
                          </div>
                        </template>
                        <vs-checkbox
                          v-else
                          class="item-box-check"
                          :readonly="board.readonly"
                          :checked="row.is_checked"
                          @change="checkForm($event, 'family_disease', indexRows)"
                        ></vs-checkbox>
                        <span class="title mr-2">{{ row.name }}</span>
                      </div>

                    </div>
                  </td>
                </tr>
              </table>

            </td>
          </tr>

<!--          측정 및 검사-->
          <tr>
            <th class="p-4 th-cell" colspan="2">{{ $t('측정 및 검사') }}</th>
          </tr>
          <tr>
            <td class="p-4 td-cell">{{ $t('비만도(BMI) 또는 허리둘레') }}</td>
            <td class="">
              <table style="width: 100%; border-spacing: 0; border-right: 1px solid #cdcdcd; border-bottom: 1px solid #cdcdcd;">
                <tr>
                  <td class="px-4" style="border-bottom: 1px solid #cdcdcd; height: 50px;" >
                    <div class="flex pr-4" style="align-items: center;">
                      <span class="title mr-2">{{ $t('체중') }}</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.weight }}</div>
                      <ml-input v-else class="input-small" v-model="form.weight" :readonly="board.readonly" />
                      <span class="title mx-2">{{ $t('kg, 신장') }}</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.height }}</div>
                      <ml-input v-else class="input-small" v-model="form.height" :readonly="board.readonly" />
                      <span class="title mx-2">cm</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="px-4" style="border-bottom: 1px solid #cdcdcd; height: 50px;" >
                    <div class="flex pr-4" style="align-items: center;">
                      <span class="title mr-2">Body Mass Index (BMI)=</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.bmi }}</div>
                      <ml-input v-else class="input-small" v-model="form.bmi" :readonly="board.readonly" />
                      <span class="title mx-2">㎏ /㎡</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="px-4" style="height: 50px;" >
                    <div class="flex pr-4" style="align-items: center;">
                      <span class="title mr-2">{{ $t('허리둘레') }}</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.waist }}</div>
                      <ml-input v-else class="input-small" v-model="form.waist" :readonly="board.readonly" />
                      <span class="title mx-2">cm</span>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td class="p-4 td-cell">{{ $t('혈압') }}</td>
            <td class="p-4 td-cell flex">
              <div class="flex pr-4" style="align-items: center;">
                <div v-if="isPrint" class="print-input text-right" >{{ form.minbp }}</div>
                <ml-input v-else class="input-small" v-model="form.minbp" :readonly="board.readonly" />
                <span class="title mx-2">/</span>
                <div v-if="isPrint" class="print-input text-right" >{{ form.maxbp }}</div>
                <ml-input v-else class="input-small" v-model="form.maxbp" :readonly="board.readonly" />
                <span class="title ml-2">mmHg</span>
              </div>
            </td>
          </tr>

          <tr>
            <td class="p-4 td-cell">{{ $t('혈중지질') }}</td>
            <td class="">
              <table style="width: 100%; border-spacing: 0; border-right: 1px solid #cdcdcd; border-bottom: 1px solid #cdcdcd;">
                <tr>
                  <td class="px-4" style="border-bottom: 1px solid #cdcdcd; height: 50px;" >
                    <div class="flex pr-4" style="align-items: center;">
                      <span class="title mr-2">{{ $t('총콜레스테롤') }}</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.cholesterol }}</div>
                      <ml-input v-else class="input-small" v-model="form.cholesterol" :readonly="board.readonly" />
                      <span class="title mx-2">㎎/㎗</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="px-4" style="border-bottom: 1px solid #cdcdcd; height: 50px;" >
                    <div class="flex pr-4" style="align-items: center;">
                      <span class="title mr-2">{{ $t('HDL 콜레스테롤') }}</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.hdl }}</div>
                      <ml-input v-else class="input-small" v-model="form.hdl" :readonly="board.readonly" />
                      <span class="title mx-2">㎎/㎗</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="px-4" style="border-bottom: 1px solid #cdcdcd; height: 50px;" >
                    <div class="flex pr-4" style="align-items: center;">
                      <span class="title mr-2">{{ $t('중성지방(트리글리세라이드)') }}</span>
                      <div v-if="isPrint" class="print-input text-right" >{{ form.triglyceride }}</div>
                      <ml-input v-else class="input-small" v-model="form.triglyceride" :readonly="board.readonly" />
                      <span class="title mx-2">㎎/㎗</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="px-4" style="height: 50px; font-weight: 500;">{{ $t('LDL 콜레스테롤 = 총콜레스테롤 - HDL 콜레스테롤 - (트리글리세라이드)/5 또는 실측치') }}</td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td class="p-4 td-cell">{{ $t('공복 혈당, 당화혈색소') }}</td>
            <td class="p-4 td-cell flex">
              <div class="flex pr-4" style="align-items: center;">
                <span class="title mr-2">{{ $t('공복혈당') }}</span>
                <div v-if="isPrint" class="print-input text-right" >{{ form.fbg }}</div>
                <ml-input v-else class="input-small" v-model="form.fbg" :readonly="board.readonly" />
                <span class="title mx-2">㎎/㎗,</span>
                <span class="title mx-2">{{ $t('식후 2시간 혈당') }}</span>
                <div v-if="isPrint" class="print-input text-right" >{{ form.pg2hr }}</div>
                <ml-input v-else class="input-small" v-model="form.pg2hr" :readonly="board.readonly" />
                <span class="title ml-2">㎎/㎗,</span>
                <span class="title ml-2">{{ $t('당화혈색소') }}</span>
                <div v-if="isPrint" class="print-input text-right" >{{ form.hba1c }}</div>
                <ml-input v-else class="input-small" v-model="form.hba1c" :readonly="board.readonly" />
                <span class="title ml-2">%</span>
              </div>
            </td>
          </tr>


          <!--          표적장기 손상 여부(심장, 신장, 망막, 혈관)-->
          <tr>
            <th class="p-4 th-cell" colspan="2">{{ $t('표적장기 손상 여부(심장, 신장, 망막, 혈관)') }}</th>
          </tr>
          <tr>
            <td class="px-4" colspan="2" style="border-bottom: 1px solid #cdcdcd; border-right: 1px solid #cdcdcd; height: 50px;" >
              <div class="flex pr-4" style="align-items: center;">
                <div
                  class="flex"
                  v-for="(row, indexRows) in form.organ_damage_1"
                  :key="indexRows"
                >
                  <template v-if="isPrint">
                    <div
                      class="item-box-check"
                      style="text-align: center;  align-self: center;"
                    >
                      <vs-icon icon="check" size="medium"></vs-icon>
                    </div>
                  </template>
                  <vs-checkbox
                    v-else
                    class="item-box-check"
                    :readonly="board.readonly"
                    :checked="row.is_checked"
                    @change="checkForm($event, 'organ_damage_1', indexRows)"
                  ></vs-checkbox>
                  <span class="title" :class="row.mini? '' : 'mr-2'">{{ row.name }}</span>
                  <span v-if="row.mini" class="small-font mr-2">{{ row.mini}}</span>
                </div>
              </div>
            </td>
          </tr>

          <!--          동반된 질병상태-->
          <tr>
            <th class="p-4 th-cell" colspan="2">{{ $t('동반된 질병상태') }}</th>
          </tr>
          <tr>
            <td class="px-4" colspan="2" style="border-bottom: 1px solid #cdcdcd; border-right: 1px solid #cdcdcd; height: 50px;" >
              <div class="flex pr-4" style="align-items: center;">
                <div
                  class="flex"
                  v-for="(row, indexRows) in form.organ_damage_2"
                  :key="indexRows"
                >
                  <template v-if="isPrint">
                    <div
                      class="item-box-check"
                      style="text-align: center;  align-self: center;"
                    >
                      <vs-icon icon="check" size="medium"></vs-icon>
                    </div>
                  </template>
                  <vs-checkbox
                    v-else
                    class="item-box-check"
                    :readonly="board.readonly"
                    :checked="row.is_checked"
                    @change="checkForm($event, 'organ_damage_2', indexRows)"
                  ></vs-checkbox>
                  <span class="title" :class="row.mini? '' : 'mr-2'">{{ row.name }}</span>
                  <span v-if="row.mini" class="small-font mr-2">{{ row.mini}}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="px-4" colspan="2" style="border-bottom: 1px solid #cdcdcd; border-right: 1px solid #cdcdcd; height: 50px;" >
              <div class="flex pr-4" style="align-items: center;">
                <span class="title m-2">
                  <div>{{ $t('· 주1) 자궁절제술을 받았거나 폐경기 이후의 여자는 나이에 무관') }}</div>
                  <div>{{ $t('· 주2) 1주일에 최소한 3일 이상, 1회에 30분 이상의 운동이 아니면 운동부족으로 간주') }}</div>
                  <div>{{ $t('· 주3) 남성 55세 미만, 여성 65세 미만 심혈관질환 가족력') }}</div>
                  <div>{{ $t('· 주4) 흉부방사선검사나 심전도검사 소견으로 판단') }}</div>
                  <div>{{ $t('· 주5) 미세단백뇨(microalbuminuria) 기준은 30-300 mg/day') }}</div>
                  <div>{{ $t('· 주6) 경동맥초음파검사 또는 말초혈관검사 소견으로 판단') }}</div>
                  <div>{{ $t('· 주7) 고혈압성망막증 기준은 grade III 또는 I V') }}</div>
                  <div>{{ $t('· 주8) 뇌경색, 뇌출혈, 일과성허혈발작, 심근경색증, 협심증, 관상동맥 재건술, 심부전증 등') }}</div>
                  <div>{{ $t('· 주9) 혈중크레아티닌농도가 남자 1.5 mg/dl 이상, 여자 1.4 mg/dl 이상이거나, 단백뇨(albuminuria) 300mg/day을 초과할 때 또는 신사구체여과율') }}< 60mL/min/1.73m2</div>
                </span>
              </div>
            </td>
          </tr>

        </table>
      </vs-row>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',

        inputC_1: '',
        inputC_2: '',
        inputC_3: '',

        age: '',
        family_name: '',
        family_disease_age: '',
        family_disease: [
          {name: '뇌졸증', is_checked:false},
          {name: '협심증', is_checked:false},
          {name: '심근경색증', is_checked:false}
        ],
        weight: '',
        height: '',
        bmi: '',
        waist: '',
        minbp: '',
        maxbp: '',
        cholesterol: '',
        hdl: '',
        triglyceride: '',
        ldl: '',
        fbg: '',
        pg2hr: '',
        hba1c: '',
        organ_damage_1: [
          {name: '좌심실비대', is_checked:false, mini:'주4)'},
          {name: '단백뇨', is_checked:false, mini:'주5)'},
          {name: '죽상동맥 경화증', is_checked:false, mini:'주6)'},
          {name: '고혈압성 망막증', is_checked:false, mini:'주7)'},
        ],
        organ_damage_2: [
          {name: '당뇨병', is_checked:false},
          {name: '뇌혈관 및 심혈관질환', is_checked:false, mini:'주8)'},
          {name: '신장질환', is_checked:false, mini:'주9)'},
          {name: '말초혈관질환', is_checked:false},
        ],

        stdInfo: {},
        fileList: [],
      },
    };
  },
  methods: {
    checkForm (value, text, indexRows) {
      if (text === 'family_disease') {
        this.form.family_disease[indexRows].is_checked = value.target.checked
      } else if (text === 'organ_damage_1') {
        this.form.organ_damage_1[indexRows].is_checked = value.target.checked
      } else if (text === 'organ_damage_2') {
        this.form.organ_damage_2[indexRows].is_checked = value.target.checked
      }
    }
  },
};
</script>


<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.table-wrap {
  width: 100%;
  border-spacing: 0;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}

.th-cell {
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.th-cell:nth-child(1) {
  max-width: 130px;
  width: 130px;
}

.th-cell:nth-child(2) {
  max-width: 390px;
  width: 390px;
}

.td-cell {
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  height: 50px;
}
.td-cell:first-child {
  background-color: #f9f9f9;
  width: 240px;
}
.td-cell:nth-child(1) {
  text-align: center;
}
.input-small {
  width: 95px;
}
.small-font {
  color: #696D71;
  font-size: 9px;
  position: relative;
  bottom: 10px;
  padding-left: 4px;
}
</style>
